import React from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../redux/slices/authSlice';
import '../styles/Auth.css';

const LoginForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector(state => state.auth);

  const onFinish = async (values) => {
    try {
      const result = await dispatch(loginUser(values)).unwrap();
      message.success('Login successful!');
      // Redirect to dashboard
      window.location.href = '/dashboard';
    } catch (err) {
      message.error(err || 'Login failed');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>HRMS Login</h1>
        <Spin spinning={isLoading}>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Invalid email format' }
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>

            {error && <div className="error-message">{error}</div>}

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={isLoading}
              >
                Login
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default LoginForm;
